import {Paging, Sorting} from '../helpers/constants';
import {handleLoading} from '../helpers/reduxHelpers';

import {ticketActionTypes as types} from '../actions/actionTypes';

export const TicketListType = {
  allTickets: 'admin',
  myTickets: 'my',
};

const initialState = {
  allChecked: false,
  elasticSearchEnabled: true,
  listType: null,
  loading: {
    priorityColors: true,
    tickets: true,
    ticketColumns: true,
    ticketStats: true,
    ticketStatuses: false,
    updateTicketColumns: false,
  },
  priorityColors: [],
  selectedCount: 0,
  stats: [],
  tableColumns: [],
  tableOptions: {
    filterOption: 0,
    pageInfo: {
      pageNumber: 1,
      pageSize: Paging.initialPageSize,
      pageSizes: Paging.pageSizes,
    },
    sortInfo: {
      sortColumn: 'TicketId',
      sortOrder: Sorting.desc,
    },
  },
  totalRows: 0,
  totals: {},
  tickets: null,
  ticketGroups: [],
  ticketStatuses: [],
  ticketTypeColors: [],
};

export default function tickets(state = initialState, action) {
  switch (action.type) {
    case types.ELASTIC_SEARCH.LOADING:
    case types.PRIORITY_COLORS.LOADING:
    case types.TICKETS.LOADING:
    case types.TICKET_COLUMNS.LOADING:
    case types.TICKET_STATS.LOADING:
    case types.TICKET_STATUSES.LOADING:
    case types.TICKET_TYPE_COLORS.LOADING:
    case types.UPDATE_TICKET_COLUMNS.LOADING:
    case types.UPDATE_TICKET_STATUS.LOADING:
      return {
        ...state,
        loading: handleLoading(state.loading, action),
      };

    case types.UPDATE_TICKET_COLUMNS.COMPLETE:
    case types.UPDATE_TICKET_STATUS.COMPLETE:
      return {
        ...state,
        loading: handleLoading(state.loading, {
          field: action.field,
          loading: false,
        }),
      };

    case types.TICKETS.COMPLETE:
      return {
        ...state,
        loading: handleLoading(state.loading, {
          field: action.field,
          loading: false,
        }),
        tickets: action.payload.data,
        ticketGroups: action.payload.ticketGroups,
        totalRows: action.payload.total.Total,
        totals: action.payload.total,
      };

    case types.ELASTIC_SEARCH.COMPLETE:
    case types.PRIORITY_COLORS.COMPLETE:
    case types.TICKET_COLUMNS.COMPLETE:
    case types.TICKET_STATS.COMPLETE:
    case types.TICKET_STATUSES.COMPLETE:
    case types.TICKET_TYPE_COLORS.COMPLETE:
      return action.stateField
        ? {
            ...state,
            loading: handleLoading(state.loading, {
              field: action.field,
              loading: false,
            }),
            [action.stateField]: action.payload,
          }
        : state;

    case types.TICKETS_LIST.PAGE_CHANGED:
      return {
        ...state,
        tableOptions: {
          ...state.tableOptions,
          pageInfo: {
            ...state.tableOptions.pageInfo,
            pageNumber: action.payload.pageNumber,
            pageSize: action.payload.pageSize,
          },
        },
      };

    case types.TICKETS_LIST.SORT_CHANGED:
      return {
        ...state,
        tableOptions: {
          ...state.tableOptions,
          sortInfo: {
            ...state.tableOptions.sortInfo,
            sortColumn: action.payload.sortColumn,
            sortOrder: action.payload.sortOrder,
          },
        },
      };

    case types.TICKETS_LIST.FILTER_OPTION_CHANGED:
      return {
        ...state,
        tableOptions: {
          ...state.tableOptions,
          filterOption: action.payload,
        },
      };

    case types.TICKETS_LIST.ITEM_CHECKED_CHANGED: {
      const {tickets} = state;
      const allChecked = false;
      const updatedTickets =
        tickets &&
        tickets.map(ticket => ({
          ...ticket,
          isChecked:
            ticket.TicketId === action.payload.TicketId
              ? !ticket.isChecked
              : ticket.isChecked,
        }));

      return {
        ...state,
        allChecked,
        selectedCount: updatedTickets.filter(ticket => !!ticket.isChecked)
          .length,
        tickets: updatedTickets,
      };
    }

    case types.TICKETS_LIST.ALL_CHECKED_CHANGED: {
      const {tickets} = state;
      const updatedTickets =
        tickets &&
        tickets.map(ticket => ({
          ...ticket,
          isChecked: action.payload,
        }));

      return {
        ...state,
        allChecked: action.payload,
        selectedCount: action.payload ? updatedTickets.length : 0,
        tickets: updatedTickets,
      };
    }

    case types.UPDATE_TICKET_LIST_TYPE:
      return {...state, listType: action.payload};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ticketReducer.js